/*
 * @Author: your name
 * @Date: 2021-12-27 09:37:34
 * @LastEditTime: 2021-12-27 09:37:35
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /fe-eshotel/src/common/gps.js
 */
/* eslint-disable */
const X_PI = Math.PI * 3000.0 / 180.0;
const MAPTYPE_WGS = 'wgs';
const MAPTYPE_BAIDU = 'baidu';

function outOfChina (lat, lng) {
  return lat < 0.8293 || lat > 55.8271 || lng < 72.004 || lng > 137.8347;
}

function transformLat (x, y) {
  let ret = -100.0 + 2.0 * x + 3.0 * y + 0.2 * y * y + 0.1 * x * y + 0.2 * Math.sqrt(Math.abs(x));
  ret += (20.0 * Math.sin(6.0 * x * Math.PI) + 20.0 * Math.sin(2.0 * x * Math.PI)) * 2.0 / 3.0;
  ret += (20.0 * Math.sin(y * Math.PI) + 40.0 * Math.sin(y / 3.0 * Math.PI)) * 2.0 / 3.0;
  ret += (160.0 * Math.sin(y / 12.0 * Math.PI) + 320 * Math.sin(y * Math.PI / 30.0)) * 2.0 / 3.0;
  return ret;
}

function transformLng (x, y) {
  let ret = 300.0 + x + 2.0 * y + 0.1 * x * x + 0.1 * x * y + 0.1 * Math.sqrt(Math.abs(x));
  ret += (20.0 * Math.sin(6.0 * x * Math.PI) + 20.0 * Math.sin(2.0 * x * Math.PI)) * 2.0 / 3.0;
  ret += (20.0 * Math.sin(x * Math.PI) + 40.0 * Math.sin(x / 3.0 * Math.PI)) * 2.0 / 3.0;
  ret += (150.0 * Math.sin(x / 12.0 * Math.PI) + 300.0 * Math.sin(x / 30.0 * Math.PI)) * 2.0 / 3.0;
  return ret;
}

function delta (lat, lng) {
  const a = 6378245.0; // 卫星椭球坐标投影到平面地图坐标系的投影因子。
  const ee = 0.00669342162296594323; // 椭球的偏心率。
  let dLat = transformLat(lng - 105.0, lat - 35.0);
  let dLng = transformLng(lng - 105.0, lat - 35.0);
  let radLat = lat / 180.0 * Math.PI;
  let magic = Math.sin(radLat);
  magic = 1 - ee * magic * magic;
  let sqrtMagic = Math.sqrt(magic);
  dLat = (dLat * 180.0) / ((a * (1 - ee)) / (magic * sqrtMagic) * Math.PI);
  dLng = (dLng * 180.0) / (a / sqrtMagic * Math.cos(radLat) * Math.PI);
  return {
    lat: dLat,
    lng: dLng,
  };
}

function wgsToSoso (lat, lng) {
  if (outOfChina(lat, lng)) {
    return {
      lat,
      lng,
    };
  }

  const d = delta(lat, lng);
  return {
    lat: parseFloat(lat) + parseFloat(d.lat),
    lng: parseFloat(lng) + parseFloat(d.lng),
  };
}

function baiduToSoso (lat, lng) {
  let x = lng - 0.0065;
  let y = lat - 0.006;
  let z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * X_PI);
  let theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * X_PI);
  let gcjLng = z * Math.cos(theta);
  let gcjLat = z * Math.sin(theta);
  return {
    lat: parseFloat(gcjLat),
    lng: parseFloat(gcjLng),
  };
}

/**
 * 把坐标系转换成soso
 * @param maptype
 * @param lat
 * @param lng
 * @return {*}
 */
export function coordConvertToSoso ({ maptype, lat, lng }) {
  if (maptype === MAPTYPE_WGS) {
    return wgsToSoso(lat * 1, lng * 1);
  } else if (maptype === MAPTYPE_BAIDU) {
    return baiduToSoso(lat * 1, lng * 1);
  }
  return {
    lat,
    lng,
  };
}
/* eslint-enable */
